import { Injectable } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import {
  RemoveAbsuidAction,
  SetAbsuidAction,
} from '../../states/calculated-price-state/calculated-price.actions';
import { TestParamsStateModel } from '../../states/calculated-price-state/calculated-price.model';
import { CalculatedPriceState } from '../../states/calculated-price-state/calculated-price.state';

@UntilDestroy()
@Injectable()
export class AbsuidService {
  constructor(private store: Store) {
    this.absuidData();
    this.testParamsData();
  }

  @Select(CalculatedPriceState.absuid) absuid$: Observable<string>;
  @Select(CalculatedPriceState.testParams)
  testParams$: Observable<TestParamsStateModel>;
  absuid: string;
  testParams: TestParamsStateModel;

  getAbsuid(): string {
    this.generateAbsuid();
    return this.absuid;
  }

  getTestParams(): TestParamsStateModel {
    return this.testParams;
  }

  private generateAbsuid(): void {
    const min = 1000;
    const max = 9999;
    const random = Math.floor(Math.random() * (max - min) + min).toString();
    const time = Date.now().toString();
    const absuid = time + random;
    this.store.dispatch(new SetAbsuidAction(absuid, false)); //set absuid only generate absuid if store is null. False to isParam
  }

  setAbsuidByParam(absuid: string) {
    this.store.dispatch(new SetAbsuidAction(absuid, true));  // true to isParam
  }

  removeAbsuid(): void {
    this.store.dispatch(new RemoveAbsuidAction());
  }

  private absuidData(): void {
    this.absuid$.pipe(untilDestroyed(this)).subscribe((state: string) => {
      this.absuid = state;
    });
  }

  private testParamsData(): void {
    this.testParams$
      .pipe(untilDestroyed(this))
      .subscribe((state: TestParamsStateModel) => {
        this.testParams = state;
      });
  }
}
